import Vue from 'vue';
import Store from './Store';
export const EventBus = new Vue({
    store:Store,
    mounted: function(){
    },
    methods:{
    }
});